import { AnyAction } from 'redux';
import { ReportAccess, ReportAccessActions, ReportAccessState } from './models/report-models';




const InitialState: ReportAccessState =
{
	accessRights: null,
	accessRightsLoaded: false,

};



export const reportAccessReducer = (state = InitialState, action: AnyAction): ReportAccessState => {

	switch (action.type) {

		case ReportAccessActions.SET_ACCESS_RIGHT:
			return {
				...state,
				accessRights: action.payload,
				accessRightsLoaded: true,
			};


		default: return state;
	}
};

export const setReportAccessRight = (accessRight: ReportAccess) => {
	return {
		type: ReportAccessActions.SET_ACCESS_RIGHT,
		payload: accessRight,
	};
};
